/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/cognitive-complexity */
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box/Box";
import { motion } from "framer-motion";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { layoutPrivateStyle } from "../styles/common/sidebar";
import { UserInfoCard } from "./private-routes/user";
import { AdminMenuProps } from "../shared/Interface/AdminMenuProps";
import { protectedRoutes } from "../routes/protected";
import { useDispatch, useSelector } from "react-redux";
import { selectProfileRole } from "../store/profile/selector";
import { setPath } from "../store/path/slice";
import { Navigate, useNavigate } from "react-router-dom";

export function SideMenuAdmin({ adminMenu }: AdminMenuProps) {
  // const isSmall = useMediaQuery("(min-width: 600px)");
  const [modulOpen, setModulOpen] = useState(adminMenu);
  const profileRole = useSelector(selectProfileRole);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sideMenuModel = {
    // initial1: {
    //   height: "100%",
    //   width: "240px",
    // },
    initial: {
      height: "100%",
      width: "52px",
    },
    animate: { width: modulOpen ? "52px" : "240px" },
    // animate2: { width: adminMenu ? "240px" : "52px" },
  };

  const variantSideMenu =
    // isSmall
    //   ? {
    //       initial: sideMenuModel.initial1,
    //       animate: sideMenuModel.animate1,
    //     }
    //   :
    // !modulOpen
    //   ? {
    //       initial: sideMenuModel.initial2,
    //       animate: sideMenuModel.animate2,
    //     }
    //   :
    {
      initial: sideMenuModel.initial,
      animate: sideMenuModel.animate,
    };

  const cardModel = {
    initial1: {
      width: "40px",
      margin: "10px",
      overflow: "hidden",
    },
    // initial2: {
    //   width: "40px",
    //   margin: "10px 6px",
    //   overflow: "hidden",
    // },
    animate1: {
      width: modulOpen ? "40px" : "220px",
      margin: modulOpen ? "10px 6px" : "10px",
    },
    // animate2: {
    //   width: modulOpen ? "220px" : "40px",
    //   margin: modulOpen ? "10px" : "10px 6px",
    // },
  };

  const cards =
    //   isSmall
    //     ? {
    //         initial: cardModel.initial1,
    //         animate: cardModel.animate1,
    //       }
    //     :
    //   !modulOpen
    //     ?
    //   {
    //     initial: cardModel.initial2,
    //     animate: cardModel.animate2,
    //   };
    // :
    {
      initial: cardModel.initial1,
      animate: cardModel.animate1,
    };

  const sideMenuIconButtonModul =
    // isSmall
    //   ? adminMenu
    //     ? layoutPrivateStyle.sideMenuPrivateIconButton
    //     : layoutPrivateStyle.sideMenuPrivateIconButtonActive
    //   :
    !modulOpen
      ? // ? !adminMenu
        //   ? layoutPrivateStyle.sideMenuPrivateIconButtonActive
        //   : layoutPrivateStyle.sideMenuPrivateIconButton
        // : adminMenu
        layoutPrivateStyle.sideMenuPrivateIconButtonActive
      : layoutPrivateStyle.sideMenuPrivateIconButton;

  const handleOpen = () => {
    // if (isSmall) setModulOpen(!modulOpen);
    setModulOpen((prev) => !prev);
  };

  return (
    <motion.div
      key="animate-sidemenu"
      initial={variantSideMenu.initial}
      animate={variantSideMenu.animate}
    >
      <Box sx={layoutPrivateStyle.sideMenuPaperBox} className="bg-primary-main">
        <IconButton
          onClick={handleOpen}
          color="primary"
          sx={sideMenuIconButtonModul}
        >
          {
            // isSmall ? (
            //   !adminMenu ? (
            //     <KeyboardDoubleArrowLeftIcon
            //       sx={layoutPrivateStyle.sideMenuPrivateIcon}
            //     />
            //   ) : (
            //     <KeyboardDoubleArrowRightIcon
            //       sx={layoutPrivateStyle.sideMenuPrivateIcon}
            //     />
            //   )
            // ) :
            // modulOpen ? (
            //   !modulOpen ? (
            //     <KeyboardDoubleArrowLeftIcon
            //       sx={layoutPrivateStyle.sideMenuPrivateIcon}
            //     />
            //   ) : (
            //     <KeyboardDoubleArrowRightIcon
            //       sx={layoutPrivateStyle.sideMenuPrivateIcon}
            //     />
            //   )
            // ) :
            !modulOpen ? (
              <KeyboardDoubleArrowLeftIcon
                sx={layoutPrivateStyle.sideMenuPrivateIcon}
              />
            ) : (
              <KeyboardDoubleArrowRightIcon
                sx={layoutPrivateStyle.sideMenuPrivateIcon}
              />
            )
          }
        </IconButton>
        <motion.div
          key="animate-userinfocard"
          initial={cards.initial}
          animate={cards.animate}
        >
          <UserInfoCard adminMenu={adminMenu} modulOpen={modulOpen} />
        </motion.div>
        <List>
          {protectedRoutes
            .filter((r) => !r.access || profileRole?.access.includes(r.access))
            .map(
              (e) =>
                e.isEnabled && (
                  <ListItem
                    key={e.title}
                    disablePadding
                    className={`${
                      e?.path == window.location.pathname &&
                      "bg-[#00000073] rounded-l-full"
                    }`}
                  >
                    <ListItemButton
                      onClick={() => {
                        dispatch(setPath(e.title));
                        navigate(e?.path!);
                      }}
                      className="flex gap-2 hover:bg-[#00000073]"
                    >
                      <Typography className="text-white font-bold text-sm">
                        {e.icon}
                      </Typography>
                      <Typography
                        className={`text-white text-sm ${
                          modulOpen && "hidden"
                        }`}
                      >
                        {e.title}
                      </Typography>
                    </ListItemButton>
                  </ListItem>
                )
            )}
        </List>
      </Box>
    </motion.div>
  );
}
